/**
 * @file
 *
 * Provides and initializes legacy sticky sidebar navigation behavior.
 */

/*
	jquery.StickyNav

	Copyright (c) 2014 John David Parsons
	Licensed under the MIT, GPL licenses.

	Adds a sticky nav effect to the sidebar

	$(document).ready(function(){
		$('.sidebar').StickyNav();
	});
*/

(function($) {
	$.fn.StickyNav = function(opts) {
		opts = $.extend({}, $.fn.StickyNav.options, opts);
		
		this.each(function() {
			var el = $(this);
			
			var currentRow = el.closest('.row');
			
			if (el.find('.no-sticky').size() > 0 || !currentRow || currentRow.size() === 0) { // if any child in this element has a class of .no-sticky, cancel everything
				return this;
			}
			
			var wrapper = $('<div class="sticky-wrapper" style="position: absolute;"></div>');
			
			el.children().wrapAll(wrapper);
			
			var settings = {};
			
			wrapper = el.find('.sticky-wrapper');
			
			settings.cachedHeight = Math.max(el.outerHeight(true), wrapper.outerHeight(true));
			
			currentRow.css('min-height', settings.cachedHeight);
			
			wrapper.css('left', el.offset().left + 'px');

			// this event if fired by DirectoryProfile when after its ajax call, it inserts new jump links into the Secondary Nav
			$(document).bind('navChanged', function(){
				wrapper.css('left', el.offset().left + 'px');
				
				settings.cachedHeight = Math.max(el.outerHeight(true), wrapper.outerHeight(true));
				
				currentRow.css('min-height', settings.cachedHeight);
				
				$.fn.StickyNav.checkPosition(el, settings);
			});
			
			$(window).resize(function(){
				wrapper.css('left', el.offset().left + 'px');
				
				settings.cachedHeight = Math.max(el.outerHeight(true), wrapper.outerHeight(true));
				
				currentRow.css('min-height', settings.cachedHeight);
				
				$.fn.StickyNav.checkPosition(el, settings);
			});
			
			$(window).scroll(function(){
				$.fn.StickyNav.checkPosition(el, settings);
			});
			
			$.fn.StickyNav.checkPosition(el, settings);
		});
		
		return this;
	};
	
	$.fn.StickyNav.checkPosition = function(el, settings) {
		var currentRow = el.closest('.row');
		
		var parentWidth = el.width();
		var wrapper = el.find('.sticky-wrapper');
		
		var wrapperHeight = settings.cachedHeight;
		
		var scrollTop = $(window).scrollTop();// + $.fn.StickyNav.options.topPadding;
		
		var currentRowBottom = currentRow.offset().top + currentRow.outerHeight(true);
		var currentRowThreshold = currentRowBottom - scrollTop;// + $.fn.StickyNav.options.topPadding;
		
		var elHeight = el.outerHeight(true) + $.fn.StickyNav.options.topPadding;
		var elTop = el.offset().top;// + $.fn.StickyNav.options.topPadding;
		
		wrapper.width(parentWidth); // we must set the width because when the element becomes position: fixed; in our responsive grid, it will lose its parent width
		
		if (wrapperHeight + $.fn.StickyNav.options.topPadding > $(window).height() || $(window).width() <= $.fn.StickyNav.options.navJumpWidth) { // if the nav is taller than the window or window width is less than tablet, don't do any sticky nav stuff, this is the default state
			//console.log('nav is taller than window. wrapperHeight (+padding): ' + (wrapperHeight + $.fn.StickyNav.options.topPadding) + ' window height: ' + $(window).height());
			wrapper.css('position','static');
			wrapper.css('top', 'auto');
		} else if (elTop - $.fn.StickyNav.options.topPadding < scrollTop && wrapperHeight <= currentRowThreshold) { // if the element is above the footer and above the current scrollTop, pin it to the top
			//console.log('make sticky. elTop: ' + elTop + ' scrollTop: ' + scrollTop + ' wrapperHeight (+padding): ' + (wrapperHeight + $.fn.StickyNav.options.topPadding) + ' window height: ' + $(window).height());
			
			// Account for WordPress admin bar
			if ($('body.admin-bar')[0]) {
				var topPadding = $.fn.StickyNav.options.topPadding + 32;
			} else {
				var topPadding = $.fn.StickyNav.options.topPadding;
			}
			
			wrapper.css('position','fixed');
			wrapper.css('top', topPadding);
		} else if (elTop >= scrollTop) { // nav is below scroll, remove sticky
			//console.log('nav is below scroll, remove sticky');
			wrapper.css('position','static');
			wrapper.css('top', 'auto');
		} else if (wrapperHeight > currentRowThreshold) { // if the nav is taller than the top position of the current row it's in, give it a negative top value so that it always sits on top of the current row
			
			// Account for WordPress admin bar
			if ($('body.admin-bar')[0]) {
				var topPadding = $.fn.StickyNav.options.topPadding + 32;
			} else {
				var topPadding = $.fn.StickyNav.options.topPadding;
			}
			
			//console.log('nav is hitting bottom of row. wrapperHeight: ' + wrapperHeight + ' currentRowThreshold: ' + currentRowThreshold);
			wrapper.css('position', 'fixed');
			wrapper.css('top', (currentRowThreshold - wrapperHeight + topPadding) + 'px');
		}
	};
	
	$.fn.StickyNav.options = {
		navJumpWidth: 800,
		topPadding: 12
	};
	
}(jQuery));

$(document).ready(function() {
	
    if (typeof $({}).StickyNav == 'function' && $('.sidebar')[0]) {
        $('.sidebar').StickyNav(); // if any element inside of .sidebar has a class of .no-sticky, this plugin will be bypassed
    }
	
});
